import { createRoleAsyncResponse } from "./types";
import * as roleActions from "./roles.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiPost, API_URL_ROLE, retrieveToken } from "../../../helpers/api";

export function* createRole(action: ReturnType<typeof roleActions.createRoleAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiPost, API_URL_ROLE.CREATE_ROLE, token, action.payload);
    if (result.status === 200) {
      const parsed: createRoleAsyncResponse = yield call(result.json.bind(result));
      yield put(roleActions.createRoleAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(roleActions.createRoleAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(roleActions.createRoleAsync.failure(parsed));
  }
}

export default function* rolesSagaCreateRole() {
  yield takeEvery(roleActions.createRoleAsync.request, createRole);
}
